module.exports = __webpack_public_path__ + "img/valid.f2447ddf.png";